import type { AdminRole } from '@/lib/api-admin';

export type PaymentActionType = 'refund' | 'void';

export const PAYMENT_ROUTE_ROLES: ReadonlyArray<AdminRole> = [
  'OPS_ADMIN',
  'CS_AGENT',
  'SETTLEMENT_AGENT',
  'SUPER_ADMIN',
];

export const PAYMENT_ACTION_RBAC: Record<PaymentActionType, ReadonlyArray<AdminRole>> = {
  refund: ['SETTLEMENT_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
  void: ['SETTLEMENT_AGENT', 'OPS_ADMIN', 'SUPER_ADMIN'],
};

export const canPerformPaymentAction = (
  action: PaymentActionType,
  roles: ReadonlyArray<AdminRole>,
): boolean => PAYMENT_ACTION_RBAC[action].some((r) => roles.includes(r));
